import * as csm from './csm'

export default function checkUrlType(url: string, info: string) {
  if (url !== undefined && typeof url !== 'string') {
    const errorId = '[DVWebStorefront::URLError]'
    const message = `${errorId} ${info}\n${JSON.stringify(url, null, 2)}`
    csm.logError(new Error(errorId), message)
    console.error(message)
  }
  return url
}
